import { useState } from 'react'
import { ChevronDown } from '../icons'

function Accordion({
  label,
  labelClosed,
  position = 'below',
  className,
  children,
}: {
  label: string
  labelClosed?: string
  position?: 'above' | 'below'
  className?: string
  children: React.ReactNode
}) {
  const [isOpen, setIsOpen] = useState(false)

  const displayLabel = !isOpen ? label : labelClosed || label

  return (
    <div className="w-full">
      {position === 'above' && isOpen && <div className="w-full">{children}</div>}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`${className} ${position === 'above' ? 'border-t' : 'border-b'} w-full flex items-center justify-between py-3 px-3 text-left text-sm border-borderGray`}
      >
        <span>{displayLabel}</span>
        <div className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}>
          <ChevronDown />
        </div>
      </button>
      {position === 'below' && isOpen && <div className="w-full">{children}</div>}
    </div>
  )
}

export default Accordion
